document.addEventListener('DOMContentLoaded', function () {
  if (typeof Splide === 'undefined') return;

  const splide = new Splide('#pdp-feature-splide', {
    type: 'loop',
    perPage: 3,
    gap: '34px', // 👈 Desktop gap
    focus: 'left',
    padding: { right: '9rem' },
    pagination: true,
    arrows: true,
    trimSpace: false,
    updateOnMove: true,
    autoplay: true,
    interval: 3000,
    pauseOnHover: true,
    resetProgress: false,

    breakpoints: {
      1024: {
        perPage: 2,
        gap: '34px', // 👈 Tablet keeps same gap (optional)
        padding: { right: '9rem' },
      },
      768: {
        perPage: 1,
        gap: '20px', // 👈 Mobile gap
        padding: { right: '7rem' },
      },
    },
  });

  splide.mount();

  // Move pagination and arrows outside page-width div for proper centering/positioning
  const section = document.querySelector('.pdp-multi-feature-slider');
  const pagination = document.querySelector('#pdp-feature-splide .splide__pagination');
  const arrows = document.querySelector('#pdp-feature-splide .splide__arrows');
  if (pagination && section) {
    section.appendChild(pagination);
  }
  if (arrows && section) {
    section.appendChild(arrows);
  }
});
